var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNightlight = function SvgNightlight(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.309 13.174c.377-.178.78.194.674.597a8.242 8.242 0 0 1-2.15 3.767c-3.224 3.223-8.381 3.29-11.522.15-3.14-3.14-3.072-8.298.152-11.522a8.237 8.237 0 0 1 3.767-2.149c.403-.105.774.297.598.674-1.145 2.444-.77 5.372 1.17 7.311 1.938 1.94 4.866 2.316 7.31 1.171v0Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNightlight);
export default ForwardRef;